import {defineAction} from 'redux-define';
import {createAction, handleActions} from 'redux-actions';
import {call, put, select} from 'redux-saga/effects';
import Covert from 'covert';
import config from 'config';
import {EVENTS, STATUS, selectToken} from './utils';

const api = config.cove.api;
const CoveApi = Covert({api});

const namespace = 'api/allocations';

// Actions
const CREATE_ALLOCATION = defineAction('CREATE_ALLOCATION', EVENTS, namespace);
export const createAllocationSuccess = createAction(CREATE_ALLOCATION.SUCCESS);

// Reducer
const initialState = {};
export const reducer = handleActions({
  [CREATE_ALLOCATION.SUCCESS]: (state, action) => ({
    ...state,
    [action.payload.id]: {
      ...state[action.payload.id],
      loaded: true,
      data: action.payload.data,
    },
  }),
}, initialState);

// Selector
export const selectAllocation = (store, id) => store.data.allocations[id];

// API Calls
export const createAllocationApi = (id, data, token) => CoveApi.deals.allocate(id, data, {token});
const getW9Api = (id, token) => CoveApi.allocations.w9(id, {token});
const getSignedApi = (id, token) => CoveApi.allocations.signed(id, {token});

// Create Allocation Saga
export function* createAllocationSaga({payload}) {
  const token = yield select(selectToken);
  const data = yield call(createAllocationApi, payload.deal.id, payload.allocation, token);
  yield put(createAllocationSuccess({id: data.id, data}));
  return data;
}

// Get W9 URL Saga
export function* getW9URLSaga({payload}) {
  const {id} = payload;
  const token = yield select(selectToken);
  try {
    const {url} = yield call(getW9Api, id, token);
    return url;
  } catch (error) {
    throw error;
  }
}

// Get Signed URL Saga
export function* getSignedURLSaga({payload}) {
  const {id} = payload;
  const token = yield select(selectToken);
  try {
    const {url} = yield call(getSignedApi, id, token);
    return url;
  } catch (error) {
    throw error;
  }
}



// WEBPACK FOOTER //
// ./mobile/shared/api/allocations.js